import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($state, $scope, $stateParams, $filter, InsuranceSuiteMetadata, CancellationService, UserInfoService) {
    var ctrl = Object.create(BaseCtrl);

    //$scope.cancellation = $scope.$parent.cancellation; // cancellation object undefined
    $scope.cancellationNumber = $stateParams.cancellationNumber;
    console.log('CancellationSummaryCtrl cancellationNumber=' + $scope.cancellationNumber + ', cancellation:');
    console.log($scope.cancellation);
    //$scope.cancellationNumber = $stateParams.cancellationNumber;
    $scope.unfilteredActivities = [];
    $scope.cancellationService = CancellationService;
    console.log($scope.cancellationRefundMethod);

    ctrl.translateMessages = function (cancellation) {
        var status = cancellationStatus(cancellation);
        console.log('status', status);

        $scope.cancellationInfoMessageTitle = getInfoMessageTitle(status);
        $scope.cancellationInfoMessage1 = getInfoMessage1(status);
        //$scope.cancellationInfoMessage2 = getInfoMessage2(status);
    };

    function getInfoMessageTitle(status) {
        if (status === 'Quoted') {
            return $filter('translate')('gateway.views.cancellation-detail.Your Cancellation request has been submitted.');
        } else if (status === 'Withdrawn') {
            return $filter('translate')('gateway.views.cancellation-detail.This cancellation has been withdrawn');
        } else if (status === 'Bound') {
            return $filter('translate')('gateway.views.cancellation-detail.This cancellation has been bound');
        } else if (status === undefined) {
            $scope.hideBindCancellation = true;
            return $filter('translate')('gateway.views.cancellation-detail.This transaction cannot be completed at this time. Please contact Montana State Fund at 406-495-5000 or toll-free at 1-800-332-6102 for assistance.');
        } else {
            return null;
        }
    }

    function getInfoMessage1(status) {
        console.log(status);
        if (status === 'Quoted') {
            console.log("inside submitted2");
            return $filter('translate')('gateway.views.cancellation-detail.You will receive a notification from Montana State Fund once your order is processed.');
        } else if (status === 'Withdrawn') {
            return $filter('translate')('gateway.views.cancellation-detail.If you need to cancel the policy please create a new Cancellation');
        } else if (status === 'Bound') {
            return $filter('translate')('gateway.views.cancellation-detail.If you need to reinstate this policy please contact the underwriter');
        } else return null;
    }

    /*function getInfoMessage2(status) {
        if (status === 'Started1') {
            return $filter('translate')('gateway.views.cancellation-detail.In order to withdraw cancellation, click on Withdraw Cancellation.');
        } else return null;
    }*/

    function cancellationStatus(cancellation) {
        console.log(cancellation);
        console.log(InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode('Quoted').name);
        console.log(InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode('Draft').name);
        console.log(InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode('Canceling').name);
        // It is possible that the cancellation would not be quoted (status is draft) or canceling; treat these the same.
        /*if ((cancellation.status === InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode('Quoted').name) ||
            (cancellation.status === InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode('Draft').name) ||
            (cancellation.status === InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyPeriodStatus').getCode('Canceling').name)
        ) {
            if (cancellation.policy.latestPeriod.totalPremium.amount > parseInt(cancellation.premiumAmount)) {
            	console.log("submitted **");
            	cancellation.status = "Quoted";
            	return cancellation.status 
            }
            else return 'Started'
        }*/
        return cancellation.status;
    }

    $scope.$watch('cancellation', function () {
        // When we navigate between quote detail tiles, ui-router instantiates controllers
        // with _new_ prototypically-inherited $scope. When we update cancellation on that scope from within,
        // it does not gets updated on a parent (because of prototypical inheritance).
        // Then when we navigate between states again the change is lost.
        // This propagates the change to the parent state.
        $scope.$parent.cancellation = $scope.cancellation;

        if (angular.isDefined($scope.cancellation)) {
            ctrl.translateMessages($scope.cancellation);
        }
    });

    return ctrl.create($scope);
};
fn.$inject = ['$state', '$scope', '$stateParams', '$filter', 'InsuranceSuiteMetadata', 'CancellationService', 'UserInfoService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/controllers/cancellation/CancellationSummaryCtrl.js
// module id = 1700
// module chunks = 0